/**
 * Part of datavideo project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

const $body = $('body');

const $headerNav = $('.c-header-nav');
const $header = $('.j-header');
const $headerNavWrapper = $('.c-header-nav__wrapper');
const $menuToggler = $('.j-toggle-menu');
const $headerSearch = $('.c-header-search');

if ($body.attr('data-site') !== 'china') {
  // Nav Bar bg on scroll
  $(window).on('scroll', function () {
    let top = $(document).scrollTop();

    if (top > 50) {
      hideMenu();
      $header.addClass('bg-dark');
      $headerNavWrapper.removeClass('active-search');
      $menuToggler.removeClass('active-search');
      $headerSearch.removeClass('active');
    } else {
      showMenu();
      $header.removeClass('bg-dark');
    }
  });

  $menuToggler.on('click', (e) => {
    if ($headerNav.hasClass('c-close-nav')) {
      showMenu();
    } else {
      hideMenu();
    }
  });
} else {
  $header.addClass('bg-dark');
}

function showMenu() {
  if (!$headerNav.hasClass('c-close-nav')) {
    return;
  }

  $headerNav.removeClass('c-close-nav');
  $menuToggler.children('i').removeClass('fa-arrow-left');
  $menuToggler.children('i').addClass('fa-arrow-right');

  setTimeout(() => {
    if (!$headerNav.hasClass('c-close-nav')) {
      $headerNavWrapper.css('overflow', '');
    }
  }, 1000);
}

function hideMenu() {
  if ($headerNav.hasClass('c-close-nav')) {
    return;
  }

  $headerNav.addClass('c-close-nav');
  $menuToggler.children('i').addClass('fa-arrow-left');
  $menuToggler.children('i').removeClass('fa-arrow-right');

  $headerNavWrapper.css('overflow', 'hidden');
}

$('.j-toggle-search').on('click', () => {
  toggleHeaderSearch();
});

function toggleHeaderSearch() {
  if ($headerNav.hasClass('c-close-nav')) {
    $headerNav.toggleClass('c-close-nav');

    $menuToggler.children('i').toggleClass('fa-arrow-right');
    $menuToggler.children('i').toggleClass('fa-arrow-left');
  }

  $headerNav.toggleClass('active-search');
  $menuToggler.toggleClass('active-search');
  $headerSearch.toggleClass('active');

  if ($headerNav.hasClass('active-search')) {
    setTimeout(() => {
      $headerSearch.show();
      $('#search').focus();
    }, 300);
  } else {
    $headerSearch.hide();
  }
}
